module.exports = __webpack_public_path__ + "assets/img/btn-view-all-23d269f3.png";